import React, { Dispatch, useEffect } from "react";
import { Document, Page } from "react-pdf";
import { PDFDocumentProxy, PDFPageProxy } from "pdfjs-dist";

type Props = {
  documentUrl: string;
  pageNumbers: number[];
  selectedPage: number;
  setSelectedPage: Dispatch<React.SetStateAction<number>>;
  onLoadSuccess?: (pdf?: PDFDocumentProxy) => void;
  temporarilyDisableScrollListener?: () => void;
}

const PageThumbnails = (props: Props) => {
  const { documentUrl, pageNumbers, selectedPage, setSelectedPage, onLoadSuccess, temporarilyDisableScrollListener } = props;

  const onPageClick = (pageNumber: number) => {
    temporarilyDisableScrollListener?.();
    setSelectedPage(pageNumber);
    const page = document.querySelector(`.main-page-${pageNumber}`) as HTMLElement;
    if (page) {
      page.scrollIntoView({ inline: "center", block: "start" });
    }
  }

  const handleSuccess = (page: PDFPageProxy) => {
    if (page.pageNumber === pageNumbers.length) {
      onLoadSuccess?.()
    };
  }

  useEffect(() => {
    const thumbnail = document.querySelector(`.thumbnail-page-${selectedPage}`) as HTMLElement;
    if (!thumbnail) return;

    const scrollContainer = thumbnail.closest('.overflow-y-auto') as HTMLElement;
    if (!scrollContainer) {
      thumbnail.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const thumbnailRect = thumbnail.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();

    const isVisible =
      thumbnailRect.top >= containerRect.top &&
      thumbnailRect.bottom <= containerRect.bottom;

    if (!isVisible) {
      thumbnail.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [selectedPage]);

  return (
    <div className="fixed flex flex-col gap-4 w-24 3xl:w-32 2k:w-36 4k:w-40 items-center flex-shrink-0">
      <h3 className="text-sm font-title font-semibold w-full px-3">Pages ({pageNumbers.length})</h3>
      <Document file={documentUrl} className="flex-shrink-0 flex flex-col gap-4" loading={<div className="opacity-0" />}>
        <div className="flex flex-col w-full h-[calc(100vh-80px)] overflow-y-auto pb-24 scrollbar-hidden px-1 gap-2">
          {pageNumbers.map((n: number) =>
            <div key={n} tabIndex={0} className={`thumbnail-page-${n} relative flex flex-col items-center justify-center rounded p-2 cursor-pointer transition-all duration-75 border border-blue border-opacity-0 ${selectedPage === n ? 'bg-blue bg-opacity-5 !border-blue border-opacity-100' : 'hover:bg-blue hover:bg-opacity-5 hover:!border-blue hover:border-opacity-60'}`} onClick={() => onPageClick(n)}>
              <Page pageNumber={n} width={72} className="border border-gray-200 overflow-hidden" renderTextLayer={false} renderAnnotationLayer={false} loading={<div className="opacity-0 w-[72px]" />} onLoadSuccess={handleSuccess} />
              <h4 className="text-xs font-semibold mt-1.5">{n}</h4>
            </div>
          )}
        </div>
      </Document>
    </div>
  );
}

export default PageThumbnails;
